module.exports = __webpack_public_path__ + "static/media/compass__bg.f4a2d72c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/404/static/img/compass__bg.svg
// module id = 2076
// module chunks = 118